export default {"src":"/_next/static/media/delivery_integrity_01.8ec6393c.svg","height":90,"width":64,"blurWidth":0,"blurHeight":0};